import { useLayoutEffect, useState, type RefObject } from 'react';

/**
 * Whether the side column sits under the main one (phone, narrow tablet). The two columns wrap by
 * the width they have, not at a fixed breakpoint, so this measures where they are rather than
 * guessing a media query (APP-070, QA-029). Side by side until it can measure.
 */
export function useStacked(
  main: RefObject<HTMLElement | null>,
  side: RefObject<HTMLElement | null>,
): boolean {
  const [stacked, setStacked] = useState(false);
  useLayoutEffect(() => {
    const a = main.current;
    const b = side.current;
    if (a === null || b === null || typeof ResizeObserver === 'undefined') return;
    const measure = () => {
      // Stacked, the side column starts below the main one ends; side by side, they start level.
      setStacked(b.getBoundingClientRect().top >= a.getBoundingClientRect().bottom - 1);
    };
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(a);
    observer.observe(b);
    return () => {
      observer.disconnect();
    };
  }, [main, side]);
  return stacked;
}
